import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useUIContext } from "../../contexts/UIContext";
import ManageAddresses from "../customer/ManageAddresses"; // Import the ManageAddresses component
import { useLogoutMutation } from "../../slices/authSlice";
import { logout as logoutAction } from "../../slices/customerSlice";

const Sidebar = () => {
  const { closeSidebar, openModal } = useUIContext(); // Access UI context
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logout] = useLogoutMutation();

  // Get customer info from Redux store
  const { info: customer } = useSelector((state) => state.frontendAuth);

  // Logout handler
  const handleLogout = async () => {
    try {
      await logout().unwrap();
      dispatch(logoutAction());
      navigate("/");
      closeSidebar();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  // Menu Items
  const menuItems = [
    ...(customer
      ? [
          { label: "Orders", icon: "shopping_bag", path: "/orders" },
          { label: "Saved Items", icon: "favorite", path: "/saved-items" },
          {
            label: "Manage Account",
            icon: "manage_accounts",
            path: "/manage-account",
          },
          {
            label: "Manage Address",
            icon: "location_on",
            action: () => openModal(<ManageAddresses onClose={closeSidebar} />), // Open modal with ManageAddresses
          },
        ]
      : [{ label: "Login/ Signup", icon: "login", path: "/login" }]),
    { label: "Support", icon: "headset_mic", path: "/support" },
    { label: "Become a Vendor", icon: "storefront", path: "/create-store" },
    ...(customer ? [{ label: "Logout", icon: "logout", isLogout: true }] : []),
  ];

  return (
    <div className="fixed inset-0 z-50 flex">
      {/* Sidebar content */}
      <div className="bg-white w-64 h-full p-4 shadow-lg">
        <button
          className="material-symbols-rounded font-thin text-3xl text-agBlack mb-4"
          onClick={closeSidebar}
        >
          close
        </button>
        <ul className="space-y-4">
          {menuItems.map((item, index) => (
            <li key={index}>
              {item.action ? (
                <button
                  className="flex items-center px-3 py-2 text-agBlack hover:bg-agPrimaryLight rounded-lg w-full"
                  onClick={() => {
                    item.action();
                    closeSidebar(); // Close sidebar after action
                  }} // Trigger modal or other actions
                >
                  <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
                    {item.icon}
                  </span>
                  {item.label}
                </button>
              ) : item.isLogout ? (
                <button
                  className="flex items-center px-3 py-2 text-agBlack hover:bg-red-100 rounded-lg w-full"
                  onClick={handleLogout}
                >
                  <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
                    {item.icon}
                  </span>
                  {item.label}
                </button>
              ) : (
                <Link
                  to={item.path}
                  className="flex items-center px-3 py-2 text-agBlack hover:bg-agPrimaryLight rounded-lg"
                  onClick={closeSidebar}
                >
                  <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
                    {item.icon}
                  </span>
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
      {/* Overlay to close sidebar */}
      <div
        className="flex-1 bg-gray-800 bg-opacity-50"
        onClick={closeSidebar}
      ></div>
    </div>
  );
};

export default Sidebar;

// SIDEBAR.JS BEFORE UI CONTEXT
// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { useLogoutMutation } from "../../slices/authSlice";
// import { logout as logoutAction } from "../../slices/customerSlice";
// import ManageAddresses from "../customer/ManageAddresses";

// const Sidebar = ({ closeSidebar }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [logout] = useLogoutMutation();
//   const [isManageAddressesVisible, setIsManageAddressesVisible] =
//     useState(false); // State for ManageAddresses modal

//   useEffect(() => {
//     console.log(
//       "ManageAddresses state updated - useEffect Log:",
//       isManageAddressesVisible,
//     );
//   }, [isManageAddressesVisible]);

//   // Get customer info from Redux store
//   const { info: customer } = useSelector((state) => state.frontendAuth);

//   // Handle logout action
//   const handleLogout = async () => {
//     try {
//       await logout().unwrap();
//       dispatch(logoutAction());
//       navigate("/");
//       closeSidebar(); // Close the sidebar after logout
//     } catch (error) {
//       console.error("Logout failed:", error);
//     }
//   };

//   // Define menu items
//   const menuItems = [
//     ...(customer
//       ? [
//           { label: "Orders", icon: "shopping_bag", path: "/orders" },
//           { label: "Saved Items", icon: "favorite", path: "/saved-items" },
//           {
//             label: "Manage Account",
//             icon: "manage_accounts",
//             path: "/manage-account",
//           },
//           {
//             label: "Manage Address",
//             icon: "location_on",
//             action: () => {
//               console.log("Manage Address clicked"); // Debug log
//               setIsManageAddressesVisible(true); // Open modal
//               console.log(
//                 "isManageAddressesVisible:",
//                 isManageAddressesVisible,
//               );
//               //closeSidebar(); // Close sidebar
//               setTimeout(closeSidebar, 0);
//             },
//           },
//         ]
//       : [{ label: "Login/ Signup", icon: "login", path: "/login" }]),
//     { label: "Support", icon: "headset_mic", path: "/support" },
//     { label: "Create Store", icon: "storefront", path: "/create-store" },
//     ...(customer ? [{ label: "Logout", icon: "logout", isLogout: true }] : []),
//   ];

//   return (
//     <>
//       <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 flex">
//         <div className="bg-white w-64 h-full p-4 shadow-lg">
//           <button
//             className="material-symbols-rounded font-thin text-3xl text-agBlack mb-4"
//             onClick={closeSidebar}
//           >
//             close
//           </button>
//           <ul className="space-y-4">
//             {menuItems.map((item, index) => (
//               <li key={index}>
//                 {item.action ? (
//                   <button
//                     className="flex items-center px-3 py-2 text-agBlack hover:bg-agPrimaryLight rounded-lg w-full"
//                     onClick={item.action} // Ensure action is triggered
//                   >
//                     <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
//                       {item.icon}
//                     </span>
//                     {item.label}
//                   </button>
//                 ) : item.isLogout ? (
//                   <button
//                     className="flex items-center px-3 py-2 text-agBlack hover:bg-red-100 rounded-lg w-full"
//                     onClick={handleLogout}
//                   >
//                     <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
//                       {item.icon}
//                     </span>
//                     {item.label}
//                   </button>
//                 ) : (
//                   <Link
//                     to={item.path}
//                     className="flex items-center px-3 py-2 text-agBlack hover:bg-agPrimaryLight rounded-lg"
//                     onClick={closeSidebar}
//                   >
//                     <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
//                       {item.icon}
//                     </span>
//                     {item.label}
//                   </Link>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </div>
//         {/* Click outside sidebar to close it */}
//         <div className="flex-1" onClick={closeSidebar}></div>
//       </div>

//       {/* Manage Addresses Modal */}
//       {isManageAddressesVisible && (
//         <ManageAddresses
//           isOpen={isManageAddressesVisible}
//           onClose={() => setIsManageAddressesVisible(false)}
//         />
//       )}
//     </>
//   );
// };

// export default Sidebar;
// ================================================================================================
// ORIGINAL MOBILE SIDEBAR
// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { useLogoutMutation } from "../../slices/authSlice";
// import { logout as logoutAction } from "../../slices/customerSlice";

// const Sidebar = ({ closeSidebar }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [logout] = useLogoutMutation();

//   // Get customer info from Redux store
//   const { info: customer } = useSelector((state) => state.frontendAuth);

//   // Handle logout action
//   const handleLogout = async () => {
//     try {
//       await logout().unwrap();
//       dispatch(logoutAction());
//       navigate("/");
//       closeSidebar(); // Close the sidebar after logout
//     } catch (error) {
//       console.error("Logout failed:", error);
//     }
//   };

//   // Define common menu items
//   const commonMenuItems = [
//     {
//       label: "Become a Supplier",
//       icon: "local_shipping",
//       path: "/become-supplier",
//     },
//     { label: "Support", icon: "headset_mic", path: "/support" },
//     { label: "Create Store", icon: "storefront", path: "/create-store" },
//   ];

//   // Define guest menu items (visible when not logged in)
//   const guestMenuItems = [
//     { label: "Login/ Signup", icon: "login", path: "/login" },
//   ];

//   // Define customer menu items (visible when logged in)
//   const customerMenuItems = [
//     { label: "Orders", icon: "shopping_bag", path: "/orders" },
//     { label: "Saved Items", icon: "favorite", path: "/saved-items" },
//     {
//       label: "Manage Account",
//       icon: "manage_accounts",
//       path: "/manage-account",
//     },
//     { label: "Manage Address", icon: "location_on", path: "/manage-address" },
//   ];

//   // Define the logout item separately to ensure it is last
//   const logoutItem = { label: "Logout", icon: "logout", isLogout: true };

//   // Combine menu items based on login status
//   const menuItems = customer
//     ? [...customerMenuItems, ...commonMenuItems, logoutItem]
//     : [...guestMenuItems, ...commonMenuItems];

//   return (
//     <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 flex">
//       <div className="bg-white w-64 h-full p-4 shadow-lg">
//         <button
//           className="material-symbols-rounded font-thin text-3xl text-agBlack mb-4"
//           onClick={closeSidebar}
//         >
//           close
//         </button>
//         <ul className="space-y-4">
//           {menuItems.map((item, index) => (
//             <li key={index}>
//               {item.isLogout ? (
//                 <button
//                   className="flex items-center px-3 py-2 text-agBlack hover:bg-red-100 rounded-lg w-full"
//                   onClick={handleLogout}
//                 >
//                   <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
//                     {item.icon}
//                   </span>
//                   {item.label}
//                 </button>
//               ) : (
//                 <Link
//                   to={item.path}
//                   className="flex items-center px-3 py-2 text-agBlack hover:bg-agPrimaryLight rounded-lg"
//                   onClick={closeSidebar}
//                 >
//                   <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
//                     {item.icon}
//                   </span>
//                   {item.label}
//                 </Link>
//               )}
//             </li>
//           ))}
//         </ul>
//       </div>
//       {/* Click outside sidebar to close it */}
//       <div className="flex-1" onClick={closeSidebar}></div>
//     </div>
//   );
// };

// export default Sidebar;
// ================================================================================================
//  OLD SIDEBAR
// import React from "react";
// import { Link } from "react-router-dom";

// const Sidebar = ({ closeSidebar }) => {
//   // Define menu items with icon, label, and link
//   const menuItems = [
//     { label: "Login/ Signup", icon: "login", path: "/login" },
//     { label: "Orders", icon: "shopping_bag", path: "/orders" },
//     { label: "Saved Items", icon: "favorite", path: "/saved-items" },
//     {
//       label: "Manage Account",
//       icon: "manage_accounts",
//       path: "/manage-account",
//     },
//     {
//       label: "Become a Supplier",
//       icon: "local_shipping",
//       path: "/become-supplier",
//     },
//     { label: "Support", icon: "headset_mic", path: "/support" },
//     { label: "Manage Address", icon: "location_on", path: "/manage-address" },
//     { label: "Create Store", icon: "storefront", path: "/create-store" },
//     { label: "Logout", icon: "logout", path: "/logout", isLogout: true },
//   ];

//   return (
//     <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 flex">
//       <div className="bg-white w-64 h-full p-4 shadow-lg">
//         <button
//           className="material-symbols-rounded font-thin text-3xl text-agBlack mb-4"
//           onClick={closeSidebar}
//         >
//           close
//         </button>
//         <ul className="space-y-4">
//           {menuItems.map((item, index) => (
//             <li key={index}>
//               <Link
//                 to={item.path}
//                 className="flex items-center px-3 py-2 text-agBlack hover:bg-agPrimaryLight rounded-lg"
//                 onClick={closeSidebar} // Close sidebar when a link is clicked
//               >
//                 <span className="material-symbols-rounded font-thin text-lg text-agBlack mr-2">
//                   {item.icon}
//                 </span>
//                 {item.label}
//               </Link>
//             </li>
//           ))}
//         </ul>
//       </div>
//       {/* Click outside sidebar to close it */}
//       <div className="flex-1" onClick={closeSidebar}></div>
//     </div>
//   );
// };

// export default Sidebar;
// ===================================================================================
// // // Sidebar.js;
// // import React, { useEffect, useState } from "react";
// // import { useDispatch } from "react-redux";
// // import { Link, useNavigate, useLocation } from "react-router-dom";
// // import { useLogoutMutation } from "../../slices/authSlice";
// // import { logout } from "../../slices/vendorSlice";
// // import logo from "../../assets/images/logo.png";

// // const menuItems = [
// //   { name: "Dashboard", icon: "dashboard", path: "/" },
// //   { name: "Wallet", icon: "account_balance_wallet", path: "/wallet" },
// //   { name: "Products", icon: "inventory_2", path: "/products" },
// //   { name: "Orders", icon: "inventory", path: "/orders" },
// //   { name: "Banking", icon: "account_balance", path: "/banking" },
// //   { name: "Analytics", icon: "equalizer", path: "/analytics" },
// //   { name: "Reviews", icon: "reviews", path: "/reviews" },
// //   { name: "Transactions", icon: "add_card", path: "/transactions" },
// //   { name: "Site Management", icon: "language", path: "/site-management" },
// // ];

// // const settingsAndLogoutItems = [
// //   { name: "Settings", icon: "settings", path: "/settings" },
// //   {
// //     name: "Logout",
// //     icon: "logout",
// //     additionalClasses: "text-red-600",
// //     onClick: null,
// //   },
// // ];

// // const Sidebar = React.memo(({ isOpen, toggleSidebar, closeSidebar }) => {
// //   const location = useLocation();
// //   const [activeItem, setActiveItem] = useState("");
// //   const [logoutBackend] = useLogoutMutation();
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();

// //   useEffect(() => {
// //     const currentPath = location.pathname;
// //     const currentItem =
// //       menuItems.find((item) => item.path === currentPath) ||
// //       settingsAndLogoutItems.find((item) => item.path === currentPath);
// //     if (currentItem) {
// //       setActiveItem(currentItem.name);
// //     }
// //   }, [location.pathname]);

// //   const handleLogout = async () => {
// //     try {
// //       await logoutBackend().unwrap();
// //       dispatch(logout());
// //       navigate("/login");
// //     } catch (error) {
// //       console.error("Failed to logout:", error);
// //     }
// //   };

// //   // Assign handleLogout to the logout item
// //   settingsAndLogoutItems.find((item) => item.name === "Logout").onClick =
// //     handleLogout;

// //   return (
// //     <>
// //       {/* Desktop Sidebar */}
// //       <div
// //         className="hidden lg:flex flex-col fixed top-0 left-0 w-64 bg-white p-4 space-y-4 shadow-lg h-full border-r-2 border-agGray"
// //         style={{ height: "100vh" }}
// //       >
// //         <Link to="/">
// //           <img
// //             src={logo}
// //             alt="Agrolinka Logo"
// //             className="w-36 cursor-pointer mb-12"
// //           />
// //         </Link>
// //         <nav className="flex flex-col flex-grow space-y-2">
// //           {menuItems.map((item) => (
// //             <Link
// //               to={item.path}
// //               key={item.name}
// //               className={`flex items-center p-2 rounded-md transition-colors duration-200 ${
// //                 activeItem === item.name
// //                   ? "bg-agPrimaryLight text-sm text-agPrimary font-bold"
// //                   : "text-agLightGray text-sm hover:bg-agPrimaryLight font-light"
// //               }`}
// //               onClick={() => setActiveItem(item.name)}
// //             >
// //               <span
// //                 className={`material-icons-round mr-2 ${
// //                   activeItem === item.name
// //                     ? "text-agPrimary"
// //                     : "text-agLightGray"
// //                 } ${item.additionalClasses || ""}`}
// //               >
// //                 {item.icon}
// //               </span>
// //               {item.name}
// //             </Link>
// //           ))}
// //         </nav>
// //         <nav className="mt-auto">
// //           <Link
// //             to="/settings"
// //             className={`flex items-center p-2 text-sm rounded-md transition-colors duration-200 ${
// //               activeItem === "Settings"
// //                 ? "bg-agPrimaryLight text-agPrimary font-light"
// //                 : "text-agLightGray hover:bg-agPrimaryLight font-light"
// //             }`}
// //             onClick={() => setActiveItem("Settings")}
// //           >
// //             <span
// //               className={`material-icons-round mr-2 ${
// //                 activeItem === "Settings"
// //                   ? "text-agPrimary"
// //                   : "text-agLightGray"
// //               }`}
// //             >
// //               settings
// //             </span>
// //             Settings
// //           </Link>
// //           <div
// //             className={`flex items-center p-2 text-sm rounded-md transition-colors duration-200 cursor-pointer ${
// //               activeItem === "Logout"
// //                 ? "text-red-600 font-light"
// //                 : "text-red-600"
// //             }`}
// //             onClick={handleLogout}
// //           >
// //             <span className={`material-icons-round mr-2 text-red-600`}>
// //               logout
// //             </span>
// //             Logout
// //           </div>
// //         </nav>
// //       </div>
// //       {/* Mobile Sidebar */}
// //       <div
// //         className={`fixed inset-0 z-50 transition-transform transform ${
// //           isOpen ? "translate-x-0" : "-translate-x-full"
// //         } bg-white h-full w-64 p-4 flex flex-col space-y-4 shadow-lg lg:hidden`}
// //       >
// //         <div className="flex justify-end">
// //           <span
// //             className="material-icons-round h-6 w-6 text-agLightGray cursor-pointer"
// //             onClick={toggleSidebar}
// //           >
// //             close
// //           </span>
// //         </div>
// //         <nav className="flex flex-col space-y-2 flex-grow">
// //           {menuItems.map((item) => (
// //             <Link
// //               to={item.path}
// //               key={item.name}
// //               className={`flex items-center p-2 rounded-md transition-colors duration-200 ${
// //                 activeItem === item.name
// //                   ? "bg-agPrimaryLight text-agPrimary font-bold"
// //                   : "text-agLightGray hover:bg-agPrimaryLight font-light"
// //               }`}
// //               onClick={() => {
// //                 setActiveItem(item.name);
// //                 closeSidebar();
// //               }}
// //             >
// //               <span
// //                 className={`material-icons-round mr-2 ${
// //                   activeItem === item.name
// //                     ? "text-agPrimary"
// //                     : "text-agLightGray"
// //                 } ${item.additionalClasses || ""}`}
// //               >
// //                 {item.icon}
// //               </span>
// //               {item.name}
// //             </Link>
// //           ))}
// //         </nav>
// //         <nav className="mt-4">
// //           <Link
// //             to="/settings"
// //             className={`flex items-center p-2 rounded-md transition-colors duration-200 ${
// //               activeItem === "Settings"
// //                 ? "bg-agPrimaryLight text-agPrimary font-light"
// //                 : "text-agLightGray hover:bg-agPrimaryLight font-light"
// //             }`}
// //             onClick={() => {
// //               setActiveItem("Settings");
// //               closeSidebar();
// //             }}
// //           >
// //             <span
// //               className={`material-icons-round mr-2 ${
// //                 activeItem === "Settings"
// //                   ? "text-agPrimary"
// //                   : "text-agLightGray"
// //               }`}
// //             >
// //               settings
// //             </span>
// //             Settings
// //           </Link>
// //           <div
// //             className={`flex items-center p-2 rounded-md transition-colors duration-200 cursor-pointer ${
// //               activeItem === "Logout"
// //                 ? "text-red-600 font-light"
// //                 : "text-red-600"
// //             }`}
// //             onClick={() => {
// //               setActiveItem("Logout");
// //               handleLogout();
// //               closeSidebar();
// //             }}
// //           >
// //             <span className={`material-icons-round mr-2 text-red-600`}>
// //               logout
// //             </span>
// //             Logout
// //           </div>
// //         </nav>
// //       </div>
// //     </>
// //   );
// // });

// // export default Sidebar;

// // -------------------------------------------------------------------------------------------------

// import React from "react";
// import { Link } from "react-router-dom";

// const Sidebar = ({ closeSidebar }) => {
//   // Define menu items with icon, label, and link
//   const menuItems = [
//     { label: "Orders", icon: "shopping_bag", path: "/orders" },
//     { label: "Saved Items", icon: "favorite", path: "/saved-items" },
//     {
//       label: "Manage Account",
//       icon: "manage_accounts",
//       path: "/manage-account",
//     },
//     {
//       label: "Become a Supplier",
//       icon: "local_shipping",
//       path: "/become-supplier",
//     },
//     { label: "Support", icon: "headset_mic", path: "/support" },
//     { label: "Manage Address", icon: "location_on", path: "/manage-address" },
//     { label: "Create Store", icon: "storefront", path: "/create-store" },
//     { label: "Login/ Signup", icon: "login", path: "/login" },
//     { label: "Logout", icon: "logout", path: "/logout", isLogout: true },
//   ];

//   return (
//     <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 flex">
//       <div className="bg-white w-64 h-full p-4 shadow-lg">
//         <button
//           className="material-symbols-rounded font-thin text-3xl text-agBlack mb-4"
//           onClick={closeSidebar}
//         >
//           close
//         </button>
//         <ul className="space-y-4">
//           {menuItems.map((item, index) => (
//             <li key={index} className="flex items-center">
//               <span className="material-symbols-rounded font-thin text-2xl text-agBlack mr-2">
//                 {item.icon}
//               </span>
//               <Link
//                 to={item.path}
//                 className="text-agBlack hover:bg-agPrimaryLight w-full px-3 py-2 rounded-lg"
//                 onClick={closeSidebar} // Close sidebar when a link is clicked
//               >
//                 {item.label}
//               </Link>
//             </li>
//           ))}
//         </ul>
//       </div>
//       {/* Click outside sidebar to close it */}
//       <div className="flex-1" onClick={closeSidebar}></div>
//     </div>
//   );
// };

// export default Sidebar;
